import ApprovalStep from "./approvalStep";
import WorkflowStepInterface from "../../../../common/interfaces/workflowStepInterface";
import {PermitteeType} from "~/enums/permitteeType";

export default class InitialStep extends ApprovalStep implements WorkflowStepInterface {

  get titleOrDefault(): string {
    return this.title;
  }

  get areDataViewersConfigurable(): boolean {
    return true;
  }

  createDefaultViewers(): void {
    this.appendViewer({
      reference_id: PermitteeType.originalSubmitter.toString(),
      reference_type: PermitteeType.originalSubmitter
    });
  }
}